import React, { useEffect, useRef } from 'react';

const loadYouTubeAPI = () => {
  return new Promise((resolve) => {
    if (window.YT && window.YT.Player) {
      resolve(window.YT);
    } else {
      // Only add the script if it doesn't exist
      const existingScript = document.getElementById('youtube-iframe-api');
      if (!existingScript) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.id = 'youtube-iframe-api';
        document.body.appendChild(tag);
      }
      window.onYouTubeIframeAPIReady = () => {
        resolve(window.YT);
      };
    }
  });
};

const YouTubePlayer = ({ playlistId, startIndex = 0, onVideoChange, onPlaylistLength }) => {
  const ytPlayer = useRef(null);

  useEffect(() => {
    let isMounted = true;
    loadYouTubeAPI().then((YT) => {
      if (!isMounted) return;
      ytPlayer.current = new YT.Player('player', {
        height: '390',
        width: '640',
        playerVars: {
          listType: 'playlist',
          list: playlistId,
          index: startIndex,
        },
        events: {
          onReady: (event) => {
            const playlist = event.target.getPlaylist();
            if (onPlaylistLength) {
              onPlaylistLength(playlist.length);
            }
            // Ensure player starts at correct index
            if (startIndex > 0) {
              event.target.playVideoAt(startIndex);
            }
            if (onVideoChange) {
              onVideoChange(event.target.getPlaylistIndex());
            }
          },
          onStateChange: (event) => {
            if (
              event.data === YT.PlayerState.PLAYING ||
              event.data === YT.PlayerState.PAUSED ||
              event.data === YT.PlayerState.ENDED
            ) {
              if (onVideoChange) {
                onVideoChange(ytPlayer.current.getPlaylistIndex());
              }
            }
          },
        },
      });
    });
    return () => {
      isMounted = false;
      if (ytPlayer.current) {
        ytPlayer.current.destroy();
      }
    };
  }, [playlistId, onVideoChange, onPlaylistLength]);

  const handlePrev = () => {
    if (ytPlayer.current) {
      ytPlayer.current.previousVideo();
      if (onVideoChange) {
        setTimeout(() => onVideoChange(ytPlayer.current.getPlaylistIndex()), 500);
      }
    }
  };
  const handleNext = () => {
    if (ytPlayer.current) {
      ytPlayer.current.nextVideo();
      if (onVideoChange) {
        setTimeout(() => onVideoChange(ytPlayer.current.getPlaylistIndex()), 500);
      }
    }
  };

  return (
    <div className="YouTubePlayer">
      <div className="navigation-row">
        <button className="video-arrow-button left" onClick={handlePrev} aria-label="Previous Video" title="Go to previous video">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="20" fill="url(#prevGradient)" />
            <path d="M24 12L16 20L24 28" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
              <linearGradient id="prevGradient" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1976d2" />
                <stop offset="1" stopColor="#42a5f5" />
              </linearGradient>
            </defs>
          </svg>
        </button>
        <div className="video-player-center">
          <div className="responsive-player-wrapper">
            <div id="player" />
          </div>
        </div>
        <button className="video-arrow-button right" onClick={handleNext} aria-label="Next Video" title="Go to next video">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="20" fill="url(#nextGradient)" />
            <path d="M16 12L24 20L16 28" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
              <linearGradient id="nextGradient" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                <stop stopColor="#1976d2" />
                <stop offset="1" stopColor="#42a5f5" />
              </linearGradient>
            </defs>
          </svg>
        </button>
      </div>
    </div>
  );
}

export default YouTubePlayer;
